import './App.css';
import { Routes } from './utils';

function App() {
    return (
        <div className="App">
            <Routes />
        </div>
    );
}

export default App;
